/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShowroomDetailsFragment, ShowroomDetailsFragment, FullShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details';

/**
 * Get a single ShowroomDetails by ID (base - scalars only)
 */
export const getBaseShowroomDetailsById = gql`
  ${BaseShowroomDetailsFragment}

  query GetBaseShowroomDetailsById($id: String!, $locale: String!, $preview: Boolean) {
    showroomDetails(id: $id, locale: $locale, preview: $preview) {
      ...BaseShowroomDetailsFragment
    }
  }
`;

/**
 * Get a single ShowroomDetails by ID (standard - 1 level deep)
 */
export const getShowroomDetailsById = gql`
  ${ShowroomDetailsFragment}

  query GetShowroomDetailsById($id: String!, $locale: String!, $preview: Boolean) {
    showroomDetails(id: $id, locale: $locale, preview: $preview) {
      ...ShowroomDetailsFragment
    }
  }
`;

/**
 * Get a single ShowroomDetails by ID (full - 2 levels deep)
 */
export const getFullShowroomDetailsById = gql`
  ${FullShowroomDetailsFragment}

  query GetFullShowroomDetailsById($id: String!, $locale: String!, $preview: Boolean) {
    showroomDetails(id: $id, locale: $locale, preview: $preview) {
      ...FullShowroomDetailsFragment
    }
  }
`;

/**
 * Get all ShowroomDetails entries with pagination (base - scalars only)
 */
export const getBaseShowroomDetailss = gql`
  ${BaseShowroomDetailsFragment}

  query GetBaseShowroomDetailss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShowroomDetailsOrder]
    $where: ShowroomDetailsFilter
    $preview: Boolean
  ) {
    showroomDetailsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseShowroomDetailsFragment
      }
    }
  }
`;

/**
 * Get all ShowroomDetails entries with pagination (standard - 1 level deep)
 */
export const getShowroomDetailss = gql`
  ${ShowroomDetailsFragment}

  query GetShowroomDetailss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShowroomDetailsOrder]
    $where: ShowroomDetailsFilter
    $preview: Boolean
  ) {
    showroomDetailsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ShowroomDetailsFragment
      }
    }
  }
`;

/**
 * Get all ShowroomDetails entries with pagination (full - 2 levels deep)
 */
export const getFullShowroomDetailss = gql`
  ${FullShowroomDetailsFragment}

  query GetFullShowroomDetailss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ShowroomDetailsOrder]
    $where: ShowroomDetailsFilter
    $preview: Boolean
  ) {
    showroomDetailsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullShowroomDetailsFragment
      }
    }
  }
`;
